






































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { post } from '@/fn/ajax'
import { Input, Button, Tooltip, message } from 'ant-design-vue'
import { login } from '@/api/auth'
import { getCurrentLocale } from '@/i18n'
import { detect } from 'detect-browser'

@Component({
  components: {
    Input,
    Button,
    Tooltip
  }
})
export default class Yinhai extends ViewBase {
  uname = ''

  unameError = ''

  pwd = ''

  pwdError = ''

  img: any = {
    logo: require('./assets/logo.png'),
    v1: {
      img0: require('./assets/v1.0.png'),
      img1: require('./assets/v1.1.jpg'),
      img2: require('./assets/v1.2.jpg'),
      img3: require('./assets/v1.3.jpg'),
      img4: require('./assets/v1.4.jpg'),
      img5: require('./assets/v1.5.jpg'),
      img6: require('./assets/v1.6.jpg'),
      img7: require('./assets/v1.7.jpg'),
      img8: require('./assets/v1.9.png'),
    },
    v2: {
      img0: require('./assets/v2.0.png'),
      img1: require('./assets/v2.1.png'),
      img2: require('./assets/v2.2.png'),
      img3: require('./assets/v2.3.png'),
      img4: require('./assets/v2.4.png')
    },
    v3: {
      img0: require('./assets/v3.0.png'),
      img1: require('./assets/v3.1.png'),
      img2: require('./assets/v3.2.png'),
      img3: require('./assets/v3.3.png'),
      img4: require('./assets/v3.4.png'),
      img5: require('./assets/v3.5.png'),
    }
  }
  submitting = false

  passwordType = 'password'

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get i18n1() {
    const value = this.$t('app')
    return value as any
  }
  mounted() {
      const { name } = detect() || { name: 'chrome' }
      const tip = name == 'ie'
      ? 'Sorry, IE browser is not supported on this website. Please download Chrome, 360 browser, Edge, Firefox, Opera and other browsers to visit.'
      : !['chrome', 'safari', 'opera'].includes(name)
      ? 'Sorry, the browser you use, can\'t access this website better, use Chrome, Safari or Opea to get a better experience.'
      : ''
      if (tip) {
      setTimeout( () => {
        const el: any = document.getElementById('topbar-browser-tip')  //  createElement('div')
      el.innerHTML = `${tip}`
      } , 200 )
    }
  }
  gotop() {
    // this.$refs.inputuname.focus()
    const el: any = this.$refs.inputuname
    el.focus()
    // let docEl = document.documentElement as HTMLDivElement
    // document.getElementById("inputuname").focus();
  }
  async submit() {
    // message.error('This is a message of error');

    this.unameError = ''
    this.pwdError = ''
    if (!this.uname) {
      message.error('Please input username')
      return
    } else if (!this.pwd) {
      message.error('Please input password')
      return
    }
    this.submitting = true
    try {
      const data = await login({ uname: this.uname, pwd: this.pwd })

      const oldschool = localStorage.school
      // 本次登录和上次不一样
      if (JSON.stringify(data.school) != localStorage.school) {
        localStorage.changeschool = 'true'
      } else {
        localStorage.changeschool = 'false'
      }
      localStorage.school = JSON.stringify(data.school)
      this.$store.commit('saveLogin', data)
      this.$store.commit('setPlayList', [])
      this.$router.push({ name: 'home' })
      this.$i18n.locale = getCurrentLocale()
      // 修改浏览器提示信息
      const { name } = detect() || { name: 'chrome' }
      const tip = name == 'ie'
      ? 'Sorry, IE browser is not supported on this website. Please download Chrome, 360 browser, Edge, Firefox, Opera and other browsers to visit.'
      : !['chrome', 'safari', 'opera'].includes(name)
      ? 'Sorry, the browser you use, can\'t access this website better, use Chrome, Safari or Opea to get a better experience.'
      : ''
      if (tip) {
      setTimeout( () => {
        const el: any = document.getElementById('topbar-browser-tip')  //  createElement('div')
        el.innerHTML = `${tip}`
      } , 200 )
      }
       document.title = 'XR Education Platform'
    } catch (ex) {
      const name = `submitError${ex.s}`
      name in this ? (this as any)[name](ex) : this.handleError(ex)
    } finally {
      this.submitting = false
    }
  }

  submitError900() {
    message.error('The username is incorrect')
    this.unameError = 'The username is incorrect'
  }

  submitError901() {
    message.error('The password is incorrect')
    this.pwdError = 'The password is incorrect'
  }

  showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
  }
}
